<template>
  <div class="finder-layout">
    <!-- Хэрэглэгчийн гарын авлага -->
    <div class="m-b-20">
      <router-link to="/userGuide" class="user-guide-link">
        <div class="user-guide-card">
          <span class="guide-card-icon">🧭</span>
          <span class="guide-card-text">Тэнгэр карго – ХЭРЭГЛЭГЧИЙН ГАРЫН АВЛАГА</span>
          <i class="el-icon-arrow-right guide-card-arrow"></i>
        </div>
      </router-link>
    </div>

    <div class="finder_title">
      <p class="text_size">
        Танд шаардлагатай бараа бүтээгдэхүүнийг <br/>
        <b> Энгийн тээвэр 4-10 хоногт</b><br>
        <b> Шуурхай тээвэр 2-3 хоногт</b>
      </p>
    </div><br/>
    <div class="finder_description">
     <p class="text_size_grey">
      Бид танд хялбар, найрсаг<br /> үйлчилгээг санал болгож байна
     </p>
    </div>
    <div class="m-t-40">
      <el-input placeholder="Та ачааны трак код эсвэл утасны дугаараа оруулна уу..." v-model="track_code" class="input-with-select custom-placeholder">
        <el-button slot="append" icon="el-icon-search" @click="getTrackCodeDetail()" :disabled="!track_code"><b>Хайх</b></el-button>
      </el-input>
    </div>
    <div>
    <el-row class="checkbox_zone m-t-40 content_justify_center space_around" >
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="6">
            <img src="@/assets/check.png" width="10px" alt="Logo" /> <span>100% баталгаатай</span>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="6">
            <img src="@/assets/check.png" width="10px" alt="Logo" /> Иж бүрэн системтэй
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="6">
            <img src="@/assets/check.png" width="10px" alt="Logo" /> Хүргэлттэй
        </el-col>
    </el-row>
</div>
<div class="m-t-40">
    <el-button class="track_code_button" @click="trackCodeAddView()"> <i class="el-icon-circle-plus-outline el-icon-right"></i>Трак код бүртгэх</el-button>
    </div>
    <div class="m-t-40">
        <el-row class="checkbox_zone m-t-40 m-l-10">
        <el-col class="line" :xs="18" :sm="18" :md="20" :lg="20" :xl="20">
            <hr>
        </el-col>
        <el-col :xs="6" :sm="6" :md="4" :lg="4" :xl="4" class="finder_icons">
            <a target="_blank" href="https://www.instagram.com/tenger_cargo?igsh=MTMwdzl4OWZyZzJyMw"><i class="fa-brands fa-instagram m-l-10" style="color: #E4405F;"></i></a>
            <a target="_blank" href="https://www.facebook.com/profile.php?id=100071635914582&mibextid=wwXIfr&rdid=TB4tzIJbbsZrnAej&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1CtacEwq66%2F%3Fmibextid%3DwwXIfr#"><i class="fa-brands fa-square-facebook m-l-20" style="color: #1877F2"></i></a>
        </el-col>
      </el-row>
    </div>
    <div>
        <TrackCodeDetailDialog v-if="this.$root.trackCodeDetailDialog" :trackCodeDetailProp=track_code_detail :searchItem="this.track_code" />
        <TrackCodeAddDialog v-if="this.$root.trackCodeAddDialog" />
    </div>
  </div>
</template>

<script>
import services from '@/helpers/services'
import TrackCodeDetailDialog from './Dialog/trackCodeDetailDialog.vue'
import TrackCodeAddDialog from './Dialog/trackCodeAddDialog.vue'

export default {
  name: 'HeaderComponent',
  components: {
    TrackCodeDetailDialog,
    TrackCodeAddDialog
  },
  data () {
    return {
      track_code: null,
      phone1: null,
      track_code_detail: []
    }
  },
  methods: {
    getTrackCodeDetail () {
      this.$root.fullscreenLoading = true
      services.searchTrackCode(this.track_code)
        .then((response) => {
          if (response.type === 'success') {
            this.track_code_detail = response.data
            this.$root.trackCodeDetailDialog = true
            this.$root.fullscreenLoading = false
          } else {
            this.track_code_detail.track_code = this.track_code
            this.track_code_detail.errorrMessage = response.data
            this.$root.trackCodeDetailDialog = true
            this.$root.fullscreenLoading = false
          }
        })
    },
    trackCodeAddView () {
      this.$root.trackCodeAddDialog = true
    }
  }
}
</script>
<style>
@media all and (max-width: 991px) {
  .custom-placeholder input::placeholder {
  font-size: 10px;
}
}
@media all and (min-width: 991px) {
  .text_size {
    font-size: 30px;
  }
}
@media all and (max-width: 991px) {
  .text_size{
    font-size: 16px;
  }
}
@media all and (min-width: 991px) {
  .text_size_grey {
    font-size: 30px;
  }
}
@media all and (max-width: 991px) {
  .text_size_grey{
    font-size: 12px;
  }
}
.finder_icons{
    color: rgb(134, 134, 134);
    font-size: 20px;
}
.finder_icons i{
    margin-top: 10px;
}
hr {
  border: none;          /* Хүрээг арилгах */
  height: 2px;           /* Зураасны зузаан */
  background-color: rgb(226, 226, 226); /* Зураасны өнгө */
  margin: 20px 0;
  width: 100%;      /* Дээд доод зай */
}
.track_code_button{
    background-color: #007AFF !important;
    color: white !important;
    width: 100%;
    font-family: 'Geologica', sans-serif;
    height: 60px;
    font-weight: bolder;
    border-radius: 10px !important;
}
.checkbox_zone{
    align-items: center;
    font-family: 'Geologica', sans-serif;
    font-weight: 500;
}
.el-input-group--append .el-input__inner, .el-input-group__prepend{
    border: none;
    color: gray;
    font-family: 'Geologica', sans-serif;
    height: 60px;
    box-shadow: 0px 10px 15px #e1e1e1;
}
.el-input-group__append{
    background: #007AFF !important;
    color: white !important;
    font-family: 'Geologica', sans-serif;
    font-weight: bold;
}
  .finder-layout {
    float: right;
    margin-top: 20%;
  }

  .finder_title {
    text-align: right;
    font-family: 'Geologica', sans-serif;
    line-height: 1.5;
    word-break: break-word;
  }

  .finder_description {
    font-family: 'Geologica', sans-serif;
    color: rgb(182, 182, 182);
    text-align: right;
    font-size: 18px;
    font-weight: 200;
    line-height: 1.5;
  }

  /* Хэрэглэгчийн гарын авлагын стиль */
  .user-guide-link {
    text-decoration: none;
    display: block;
  }

  .user-guide-card {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 20px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    color: #fff;
    font-family: 'Geologica', sans-serif;
    font-weight: 600;
    font-size: 16px;
    text-align: right;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    cursor: pointer;
  }

  .user-guide-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  }

  .guide-card-icon {
    font-size: 24px;
    flex-shrink: 0;
  }

  .guide-card-text {
    flex: 1;
    text-align: right;
  }

  .guide-card-arrow {
    font-size: 18px;
    flex-shrink: 0;
    transition: transform 0.3s ease;
  }

  .user-guide-card:hover .guide-card-arrow {
    transform: translateX(-5px);
  }

  .m-b-20 {
    margin-bottom: 20px;
  }

  @media all and (max-width: 991px) {
    .user-guide-card {
      padding: 12px 16px;
      font-size: 14px;
    }

    .guide-card-icon {
      font-size: 20px;
    }

    .guide-card-arrow {
      font-size: 16px;
    }
  }

</style>
